import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCGMztzSTSwi2ecZyUs9v4N2712faAHB5o",
  authDomain: "armazon-shop.firebaseapp.com",
  databaseURL: "https://armazon-shop.firebaseio.com",
  projectId: "armazon-shop",
  storageBucket: "armazon-shop.appspot.com",
  messagingSenderId: "169922486596",
  appId: "1:169922486596:web:2d067e5e2707dc5f19f711",
  measurementId: "G-W5PL676FL8"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };